import LakeNode from "./LakeNode";
import O1HD from "../../../../engines/gameEngine";
import gameConfig from "../../../../engines/configs/gameConfig";
import utilsModel from "../../../../engines/libs/utilsModel";

const {ccclass, property} = cc._decorator;
/**
 *
 */
@ccclass
export default class AddBattleCount extends cc.Component {

    @property(cc.Label)
    lbDesc : cc.Label = null;

    private mParentScript : LakeNode;

    onLoad () {}

    start () {
        this.lbDesc.string = `${this.lbDesc.string}+${gameConfig.DRIFT_BATTLE_COUNT}`
    }


    bindData( parentScript : LakeNode ){
        this.mParentScript = parentScript;
    }

    /**
     * 关闭
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this._close();
    }

    /**
     * 解锁
     */
    onBtnUnlock(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.mParentScript.addBattleCount();
            O1HD.getModules().uiControlModule.showMessageBox("添加漂流瓶次数成功");
            this._close();
        },()=>{
            O1HD.getModules().uiControlModule.showMessageBox("观看视频失败");
        },()=>{

        },"添加漂流瓶次数" );
    }

    private _close(){
        this.node.removeFromParent();
        this.node.destroy();
    }
}
